import { useContext } from 'react';

import ErrorBoundaryContext from './error-boundary-context';

const useErrorBoundaryContext = () => useContext(ErrorBoundaryContext);

export default useErrorBoundaryContext;
